const currentYear = () =>{
    const d = new Date();
    let year = d.getFullYear();
    return year;
}

export default currentYear;